import { create } from 'zustand'

import { AccountManagementStore } from './types'

export const useAccountManagementStore = create<AccountManagementStore>(
  set => ({
    editingItem: 'none',
    setEditingItem: editingItem => set({ editingItem }),
  })
)
